import { Box, Flex, HStack, Text } from '@skin-seoul/design-system';
import JewelIcon from './Jewel';

export const SkinSeoulHiddenGems = () => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="fit-content"
      background="linear-gradient(180deg, rgba(111, 63, 215, 0.00) 0%, rgba(111, 63, 215, 0.40) 100%);"
      paddingTop="20px"
      paddingBottom="8px"
    >
      <HStack gap="8px" alignItems="center" height="100%">
        <Box width="20px" height="20px" display="flex" alignItems="center" justifyContent="center">
          <JewelIcon />
        </Box>

        <Text textStyle="label.small" fontWeight="normal" color="primary.500" whiteSpace="nowrap">
          Hidden Gems
        </Text>
      </HStack>
    </Flex>
  );
};

export default SkinSeoulHiddenGems;
